import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  useMediaQuery,
} from "@mui/material";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const styles = [
  {
    name: "PERFECT GAME",
    description: [
      "Cod Span (97% POLY/ 3% SPAN)",
      "6 Panel / Curved Visor",
      "Stretch Fit",
      "S/M (56CM) & L/XL(58CM)",
      "Camo pattern is a sublimated pattern on white",
    ],
    hatImage: ["/hat1-1.png", "/hat1-2.png", "/hat1-3.png", "/hat1-4.png"],
    colorImages: [
      process.env.PUBLIC_URL + "/BEI.svg",
      process.env.PUBLIC_URL + "/BLK.svg",
      process.env.PUBLIC_URL + "/BLU.svg",
      process.env.PUBLIC_URL + "/BOR.svg",
      process.env.PUBLIC_URL + "/CRD.svg",
      process.env.PUBLIC_URL + "/DGR.svg",
      process.env.PUBLIC_URL + "/GRY.svg",
      process.env.PUBLIC_URL + "/KGR.svg",
      process.env.PUBLIC_URL + "/NVY.svg",
      process.env.PUBLIC_URL + "/RED.svg",
      process.env.PUBLIC_URL + "/ROY.svg",
      process.env.PUBLIC_URL + "/WHT.svg",
    ],
  },
  {
    name: "AIR FLOW",
    description: [
      "POLY RIPSTOP (100% POLYESTER)",
      "6 PANEL/ SLIGHT CURVED VISOR",
      "SOLID ROPE",
      "PERFORATION ON SIDE & BACK PANELS",
      "ADJUSTABLE SNAPBACK ",
    ],
    hatImage: ["/hat2-1.png", "/hat2-2.png", "/hat2-3.png", "/hat2-4.png"],
    colorImages: [
      process.env.PUBLIC_URL + "/BLK.svg",
      process.env.PUBLIC_URL + "/BLU.svg",
      process.env.PUBLIC_URL + "/BOR.svg",
      process.env.PUBLIC_URL + "/CRD.svg",
      process.env.PUBLIC_URL + "/DGR.svg",
      process.env.PUBLIC_URL + "/GRN.svg",
      process.env.PUBLIC_URL + "/GRY.svg",
      process.env.PUBLIC_URL + "/LNV.svg",
      process.env.PUBLIC_URL + "/LSB.svg",
      process.env.PUBLIC_URL + "/LTB.svg",
      process.env.PUBLIC_URL + "/NVY.svg",
      process.env.PUBLIC_URL + "/OLV.svg",
      process.env.PUBLIC_URL + "/PNK.svg",
      process.env.PUBLIC_URL + "/PGY.svg",
      process.env.PUBLIC_URL + "/RED.svg",
      process.env.PUBLIC_URL + "/ROY.svg",
      process.env.PUBLIC_URL + "/STN.svg",
      process.env.PUBLIC_URL + "/WHT.svg",
    ],
  },
  {
    name: "LASERLUXE",
    description: [
      "REFLECTOR /TERESA (100% POLYESTER)",
      "6 PANEL / SLIGHT CURVED VISOR",
      "PERFORATION ON SIDE & BACK PANELS",
      "ADJUSTABLE VELCRO",
    ],
    hatImage: ["/hat3-1.png", "/hat3-2.png", "/hat3-3.png", "/hat3-4.png"],
    colorImages: [
      process.env.PUBLIC_URL + "/BLK.svg",
      process.env.PUBLIC_URL + "/DKC.svg",
      process.env.PUBLIC_URL + "/DKM.svg",
      process.env.PUBLIC_URL + "/DPK.svg",
      process.env.PUBLIC_URL + "/GRN.svg",
      process.env.PUBLIC_URL + "/LSB.svg",
      process.env.PUBLIC_URL + "/NVY.svg",
      process.env.PUBLIC_URL + "/ROY.svg",
      process.env.PUBLIC_URL + "/WHT.svg",
    ],
  },
  {
    name: "ROAD RUNNER",
    description: [
      "ELITE PERFORMANCE & MESH (100% POLyESTER)",
      "6 PANEL/ SLIGHT CURVED VISOR",
      "ADJUSTABLE SNAPBACK",
    ],
    hatImage: ["/hat4-1.png", "/hat4-2.png", "/hat4-3.png", "/hat4-4.png"],
    colorImages: [
      process.env.PUBLIC_URL + "/BLK.svg",
      process.env.PUBLIC_URL + "/BLU.svg",
      process.env.PUBLIC_URL + "/BOR.svg",
      process.env.PUBLIC_URL + "/CRD.svg",
      process.env.PUBLIC_URL + "/DGR.svg",
      process.env.PUBLIC_URL + "/GRN.svg",
      process.env.PUBLIC_URL + "/GRY.svg",
      process.env.PUBLIC_URL + "/LNV.svg",
      process.env.PUBLIC_URL + "/LSB.svg",
      process.env.PUBLIC_URL + "/LTB.svg",
      process.env.PUBLIC_URL + "/NVY.svg",
      process.env.PUBLIC_URL + "/OLV.svg",
      // process.env.PUBLIC_URL + "/BLK.svg",
      // process.env.PUBLIC_URL + "/GRY.svg",
      // process.env.PUBLIC_URL + "/IVY.svg",
      // process.env.PUBLIC_URL + "/KHK.svg",
      // process.env.PUBLIC_URL + "/NVY.svg",
      // process.env.PUBLIC_URL + "/WHT.svg",
    ],
    meshColors: [
      process.env.PUBLIC_URL + "/BLK.svg",
      process.env.PUBLIC_URL + "/GRY.svg",
      process.env.PUBLIC_URL + "/IVY.svg",
      process.env.PUBLIC_URL + "/KHK.svg",
      process.env.PUBLIC_URL + "/NVY.svg",
      process.env.PUBLIC_URL + "/WHT.svg",
    ],
  },
  {
    name: "HIGH POINT",
    description: [
      "POLY RIPSTOP (100% POLYESTER)",
      "5 PANEL / SLIGHT CURVED VISOR",
      "PERFORATION ON SIDE & BACK PANELS",
      "ADJUSTABLE SNAPBACK",
    ],
    hatImage: ["/hat5-1.png", "/hat5-2.png", "/hat5-3.png", "/hat5-4.png"],
    colorImages: [
      process.env.PUBLIC_URL + "/BLK.svg",
      process.env.PUBLIC_URL + "/BLU.svg",
      process.env.PUBLIC_URL + "/BOR.svg",
      process.env.PUBLIC_URL + "/CRD.svg",
      process.env.PUBLIC_URL + "/DGR.svg",
      process.env.PUBLIC_URL + "/GRN.svg",
      process.env.PUBLIC_URL + "/GRY.svg",
      process.env.PUBLIC_URL + "/LNV.svg",
      process.env.PUBLIC_URL + "/LSB.svg",
      process.env.PUBLIC_URL + "/LTB.svg",
      process.env.PUBLIC_URL + "/NVY.svg",
      process.env.PUBLIC_URL + "/OLV.svg",
      process.env.PUBLIC_URL + "/PNK.svg",
      process.env.PUBLIC_URL + "/PGY.svg",
      process.env.PUBLIC_URL + "/RED.svg",
      process.env.PUBLIC_URL + "/ROY.svg",
      process.env.PUBLIC_URL + "/STN.svg",
      process.env.PUBLIC_URL + "/WHT.svg",
    ],
  },
  {
    name: "NIGHT SHIFT",
    description: [
      "CVC HEATHER & MESH (100% POLYESTER)",
      "5 PANEL/ SLIGHT CURVED VISOR ",
      "ADJUSTABLE SNAPBACK",
    ],
    hatImage: ["/hat6-1.png", "/hat6-2.png", "/hat6-3.png", "/hat6-4.png"],
    colorImages: [
      process.env.PUBLIC_URL + "/HCHR.svg",
      process.env.PUBLIC_URL + "/HLGY.svg",
      process.env.PUBLIC_URL + "/HNVY.svg",
      // process.env.PUBLIC_URL + "/CHR.svg",
      // process.env.PUBLIC_URL + "/BLK.svg",
      // process.env.PUBLIC_URL + "/GRY.svg",
      // process.env.PUBLIC_URL + "/IVY.svg",
      // process.env.PUBLIC_URL + "/NVY.svg",
      // process.env.PUBLIC_URL + "/WHT.svg",
    ],
    meshColors: [
      process.env.PUBLIC_URL + "/CHR.svg",
      process.env.PUBLIC_URL + "/BLK.svg",
      process.env.PUBLIC_URL + "/GRY.svg",
      process.env.PUBLIC_URL + "/IVY.svg",
      process.env.PUBLIC_URL + "/NVY.svg",
      process.env.PUBLIC_URL + "/WHT.svg",
    ],
  },
  {
    name: "ULTRALITE",
    description: [
      "COOLEVER (100% POLYESTER)",
      "6 PANEL / CURVED VISOR",
      "ADJUSTABLE VELCRO",
    ],
    hatImage: ["/hat7-1.png", "/hat7-2.png", "/hat7-3.png", "/hat7-4.png"],
    colorImages: [
      process.env.PUBLIC_URL + "/BLK.svg",
      process.env.PUBLIC_URL + "/CHR.svg",
      process.env.PUBLIC_URL + "/LGY.svg",
      process.env.PUBLIC_URL + "/LSB.svg",
      process.env.PUBLIC_URL + "/LTB.svg",
      process.env.PUBLIC_URL + "/MAR.svg",
      process.env.PUBLIC_URL + "/PRP.svg",
      process.env.PUBLIC_URL + "/RED.svg",
      process.env.PUBLIC_URL + "/STN.svg",
      process.env.PUBLIC_URL + "/WHT.svg",
    ],
  },
  {
    name: "CADDY",
    description: [
      "POLY RIPSTOP (100% POLYESTER) ",
      "5 PANEL / CURVED VISOR",
      "SOLID ROPE",
      "ADJUSTABLE SNAPBACK",
    ],
    hatImage: ["/hat8-1.png", "/hat8-2.png", "/hat8-3.png", "/hat8-4.png"],
    colorImages: [
      process.env.PUBLIC_URL + "/BLK.svg",
      process.env.PUBLIC_URL + "/BLU.svg",
      process.env.PUBLIC_URL + "/BOR.svg",
      process.env.PUBLIC_URL + "/CRD.svg",
      process.env.PUBLIC_URL + "/DGR.svg",
      process.env.PUBLIC_URL + "/GRN.svg",
      process.env.PUBLIC_URL + "/GRY.svg",
      process.env.PUBLIC_URL + "/LNV.svg",
      process.env.PUBLIC_URL + "/LSB.svg",
      process.env.PUBLIC_URL + "/LTB.svg",
      process.env.PUBLIC_URL + "/NVY.svg",
      process.env.PUBLIC_URL + "/OLV.svg",
      process.env.PUBLIC_URL + "/PNK.svg",
      process.env.PUBLIC_URL + "/PGY.svg",
      process.env.PUBLIC_URL + "/RED.svg",
      process.env.PUBLIC_URL + "/ROY.svg",
      process.env.PUBLIC_URL + "/STN.svg",
      process.env.PUBLIC_URL + "/WHT.svg",
    ],
  },
  {
    name: "CREW",
    description: [
      "WASHED 16'S TWILL (100% COTTON) ",
      "6 PANEL/ CURVED VISOR ",
      "ADJUSTABLE STRAPBACK",
    ],
    hatImage: ["/hat9-1.png", "/hat9-2.png", "/hat9-3.png", "/hat9-4.png"],
    colorImages: [
      process.env.PUBLIC_URL + "/BLK.svg",
      process.env.PUBLIC_URL + "/BLU.svg",
      process.env.PUBLIC_URL + "/BOR.svg",
      process.env.PUBLIC_URL + "/CRD.svg",
      process.env.PUBLIC_URL + "/DGR.svg",
      process.env.PUBLIC_URL + "/GRN.svg",
      process.env.PUBLIC_URL + "/GRY.svg",
      process.env.PUBLIC_URL + "/LNV.svg",
      process.env.PUBLIC_URL + "/LSB.svg",
      process.env.PUBLIC_URL + "/LTB.svg",
      process.env.PUBLIC_URL + "/NVY.svg",
      process.env.PUBLIC_URL + "/OLV.svg",
      process.env.PUBLIC_URL + "/PNK.svg",
      process.env.PUBLIC_URL + "/PGY.svg",
      process.env.PUBLIC_URL + "/RED.svg",
      process.env.PUBLIC_URL + "/ROY.svg",
      process.env.PUBLIC_URL + "/STN.svg",
      process.env.PUBLIC_URL + "/WHT.svg",
    ],
  },
  {
    name: "OFFROAD",
    description: [
      "WASHED 16'S TWILL & SOFT MESH (50% COTTON / 50% POLYESTER)",
      "6 PANEL/ CURVED VISOR",
      "ADJUSTABLE SNAPBACK",
    ],
    hatImage: ["/hat10-1.png", "/hat10-2.png", "/hat10-3.png", "/hat10-4.png"],
    colorImages: [
      process.env.PUBLIC_URL + "/BLK.svg",
      process.env.PUBLIC_URL + "/BLU.svg",
      process.env.PUBLIC_URL + "/BOR.svg",
      process.env.PUBLIC_URL + "/CRD.svg",
      process.env.PUBLIC_URL + "/DGR.svg",
      process.env.PUBLIC_URL + "/GRN.svg",
      process.env.PUBLIC_URL + "/GRY.svg",
      process.env.PUBLIC_URL + "/LNV.svg",
      process.env.PUBLIC_URL + "/LSB.svg",
      process.env.PUBLIC_URL + "/LTB.svg",
      process.env.PUBLIC_URL + "/NVY.svg",
      process.env.PUBLIC_URL + "/OLV.svg",
      process.env.PUBLIC_URL + "/PNK.svg",
      process.env.PUBLIC_URL + "/PGY.svg",
      process.env.PUBLIC_URL + "/RED.svg",
      process.env.PUBLIC_URL + "/ROY.svg",
      process.env.PUBLIC_URL + "/STN.svg",
      process.env.PUBLIC_URL + "/WHT.svg",
      // process.env.PUBLIC_URL + "/CHR.svg",
      // process.env.PUBLIC_URL + "/BLK.svg",
      // process.env.PUBLIC_URL + "/GRY.svg",
      // process.env.PUBLIC_URL + "/IVY.svg",
      // process.env.PUBLIC_URL + "/NVY.svg",
      // process.env.PUBLIC_URL + "/WHT.svg",
    ],
    meshColors: [
      process.env.PUBLIC_URL + "/CHR.svg",
      process.env.PUBLIC_URL + "/BLK.svg",
      process.env.PUBLIC_URL + "/GRY.svg",
      process.env.PUBLIC_URL + "/IVY.svg",
      process.env.PUBLIC_URL + "/NVY.svg",
      process.env.PUBLIC_URL + "/WHT.svg",
    ],
  },
  {
    name: "6-BELOW",
    description: [
      "POLY RIPSTOP (100% POLYESTER)",
      "6 PANEL / FLAT BILL VISOR",
      "PERFORATION ON SIDE & BACK PANELS",
      "ADJUSTABLE SNAPBACK",
    ],
    hatImage: ["/hat11-1.png", "/hat11-2.png", "/hat11-3.png", "/hat11-4.png"],
    colorImages: [
      process.env.PUBLIC_URL + "/BLK.svg",
      process.env.PUBLIC_URL + "/BLU.svg",
      process.env.PUBLIC_URL + "/BOR.svg",
      process.env.PUBLIC_URL + "/CRD.svg",
      process.env.PUBLIC_URL + "/DGR.svg",
      process.env.PUBLIC_URL + "/GRN.svg",
      process.env.PUBLIC_URL + "/GRY.svg",
      process.env.PUBLIC_URL + "/LNV.svg",
      process.env.PUBLIC_URL + "/LSB.svg",
      process.env.PUBLIC_URL + "/LTB.svg",
      process.env.PUBLIC_URL + "/NVY.svg",
      process.env.PUBLIC_URL + "/OLV.svg",
      process.env.PUBLIC_URL + "/PNK.svg",
      process.env.PUBLIC_URL + "/PGY.svg",
      process.env.PUBLIC_URL + "/RED.svg",
      process.env.PUBLIC_URL + "/ROY.svg",
      process.env.PUBLIC_URL + "/STN.svg",
      process.env.PUBLIC_URL + "/WHT.svg",
    ],
  },
  {
    name: "ULTRALITE VISOR ",
    description: [
      "COOLEVER (100% POLYESTER)",
      "STANDARD VISOR",
      "ADJUSTABLE VELCRO",
    ],
    hatImage: ["/hat12-1.png", "/hat12-2.png", "/hat12-3.png", "/hat12-4.png"],
    colorImages: [
      process.env.PUBLIC_URL + "/BLK.svg",
      process.env.PUBLIC_URL + "/CHR.svg",
      process.env.PUBLIC_URL + "/LGY.svg",
      process.env.PUBLIC_URL + "/LSB.svg",
      process.env.PUBLIC_URL + "/LTB.svg",
      process.env.PUBLIC_URL + "/MAR.svg",
      process.env.PUBLIC_URL + "/PRP.svg",
      process.env.PUBLIC_URL + "/RED.svg",
      process.env.PUBLIC_URL + "/STN.svg",
      process.env.PUBLIC_URL + "/WHT.svg",
    ],
  },
];

const HatStylesPage = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const [zoomedImageIdx, setZoomedImageIdx] = useState({});

  const handleImageClick = (styleIndex, imageIndex, e) => {
    const imgElement = e.target;
    const rect = imgElement.getBoundingClientRect();

    const clickX = e.clientX - rect.left;
    const clickY = e.clientY - rect.top;

    const xPercentage = (clickX / rect.width) * 100;
    const yPercentage = (clickY / rect.height) * 100;

    setZoomedImageIdx((prevState) => ({
      ...prevState,
      [styleIndex]: prevState[styleIndex] === imageIndex ? null : imageIndex,
    }));

    imgElement.style.transformOrigin = `${xPercentage}% ${yPercentage}%`;
  };

  const handleResetZoom = () => {
    setZoomedImageIdx({});
  };

  return (
    <Box sx={{ padding: "30px" }}>
      {styles.map((hat, index) => (
        <Box
          key={index}
          sx={{
            borderRadius: "8px",
            marginBottom: "30px",
          }}
        >
          <Grid container spacing={isMobile ? 0 : 4} alignItems="center">
            {/* Hat Image (Left Side) */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Box
                sx={{
                  backgroundColor: index % 2 === 0 ? "#ECECEC" : "#E8F1FB",
                  padding: { xs: "20px", md: "20px 40px" },
                  borderRadius: "8px",
                  display: "flex",
                  justifyContent: "center",
                  width: { xs: "100%", md: "85%" },
                }}
              >
                <Carousel
                  infiniteLoop={true}
                  showThumbs={false}
                  showIndicators={true}
                  showStatus={false}
                  onChange={handleResetZoom}
                  renderArrowPrev={(onClickHandler, hasPrev) => (
                    <button
                      onClick={() => {
                        onClickHandler();
                        handleResetZoom();
                      }}
                      disabled={!hasPrev}
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "0",
                        transform: "translateY(-50%)",
                        background: "transparent",
                        border: "none",
                        color: "black",
                        fontSize: "30px",
                        zIndex: 10,
                        cursor: "pointer",
                      }}
                    >
                      &#10094; {/* Left Arrow Symbol */}
                    </button>
                  )}
                  renderArrowNext={(onClickHandler, hasNext) => (
                    <button
                      onClick={() => {
                        onClickHandler();
                        handleResetZoom();
                      }}
                      disabled={!hasNext}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "0",
                        transform: "translateY(-50%)",
                        background: "transparent",
                        border: "none",
                        color: "black",
                        fontSize: "30px",
                        zIndex: 10,
                        cursor: "pointer",
                      }}
                    >
                      &#10095; {/* Right Arrow Symbol */}
                    </button>
                  )}
                  renderIndicator={(
                    onClickHandler,
                    isSelected,
                    index,
                    label
                  ) => (
                    <li
                      style={{
                        margin: "0 5px",
                        display: "inline-block",
                        cursor: "pointer",
                        padding: "5px",
                        backgroundColor: isSelected ? "#FF8300" : "#000",
                        borderRadius: "50%",
                        transition: "background-color 0.3s ease",
                      }}
                      onClick={() => {
                        onClickHandler();
                        handleResetZoom();
                      }}
                      key={index}
                      aria-label={label}
                    />
                  )}
                >
                  {hat.hatImage.map((image, imgIndex) => (
                    <div
                      key={imgIndex}
                      onClick={(e) => handleImageClick(index, imgIndex, e)}
                      style={{
                        transform:
                          zoomedImageIdx[index] === imgIndex
                            ? "scale(2)"
                            : "scale(1)",
                        transition: "transform 0.3s ease",
                        cursor:
                          zoomedImageIdx[index] === imgIndex
                            ? "zoom-out"
                            : "zoom-in",
                      }}
                    >
                      <img
                        src={image}
                        alt={`${hat.name}-${imgIndex}`}
                        style={{
                          width: "80%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  ))}
                </Carousel>
              </Box>
            </Grid>

            {/* Description and Color Options (Right Side) */}
            <Grid item xs={12} md={6} pt={0}>
              <Card sx={{ padding: 2, boxShadow: "none", border: "none" }}>
                <CardContent>
                  {/* Hat Name */}
                  <Typography
                    variant="h5"
                    color="#193059"
                    sx={{
                      fontWeight: "bold",
                      fontSize: { xs: "1.2rem", md: "1.5rem" },
                    }}
                  >
                    {hat.name}
                  </Typography>

                  {/* Bullet Points Description */}
                  <ul style={{ paddingLeft: "20px", margin: 0 }}>
                    {hat.description.map((point, idx) => (
                      <li key={idx} style={{ marginBottom: "4px" }}>
                        <Typography
                          variant="body2"
                          fontWeight="bold"
                          textTransform="uppercase"
                          color="#193059"
                          sx={{
                            textAlign: "left",
                            padding: 0,
                          }}
                        >
                          {point}
                        </Typography>
                      </li>
                    ))}
                  </ul>
                  <Grid
                    container
                    mt={3}
                    spacing={1}
                    sx={{
                      width: { xs: "100%", md: "50%" },
                      justifyContent: { xs: "center", md: "flex-start" },
                      textAlign: { xs: "center", md: "left" },
                    }}
                  >
                    {Array.from({
                      length: Math.ceil(hat.colorImages.length / 6),
                    }).map((_, rowIndex) => {
                      const startIndex = rowIndex * 6;
                      const endIndex = Math.min(
                        startIndex + 6,
                        hat.colorImages.length
                      );

                      return (
                        <Grid container item key={rowIndex} spacing={1}>
                          {hat.colorImages
                            .slice(startIndex, endIndex)
                            .map((img, idx) => (
                              <Grid
                                item
                                xs={4}
                                sm={2}
                                md={2}
                                key={startIndex + idx}
                              >
                                <img
                                  src={img}
                                  alt={`${hat.name} color ${
                                    startIndex + idx + 1
                                  }`}
                                />
                              </Grid>
                            ))}
                        </Grid>
                      );
                    })}
                  </Grid>

                  {/* Add another row for meshColors */}
                  {hat.meshColors?.length > 0 && (
                    <Grid
                      container
                      mt={3}
                      spacing={1}
                      sx={{
                        width: { xs: "100%", md: "50%" },
                        justifyContent: { xs: "center", md: "flex-start" },
                        textAlign: { xs: "center", md: "left" },
                      }}
                    >
                      <Box
                        sx={{
                          borderBottom: "2px solid #EAEAE9",
                          width: "100%",
                          mb: 1,
                        }}
                      >
                        <Typography variant="body2" color="#7B868C">
                          Mesh Colors
                        </Typography>
                      </Box>
                      {Array.from({
                        length: Math.ceil(hat.meshColors.length / 6),
                      }).map((_, rowIndex) => {
                        const startIndex = rowIndex * 6;
                        const endIndex = Math.min(
                          startIndex + 6,
                          hat.meshColors.length
                        );

                        return (
                          <Grid container item key={rowIndex} spacing={1}>
                            {hat.meshColors
                              .slice(startIndex, endIndex)
                              .map((color, idx) => (
                                <Grid
                                  item
                                  xs={4}
                                  sm={2}
                                  md={2}
                                  key={startIndex + idx}
                                >
                                  <img
                                    src={color}
                                    alt={`${hat.name} color ${
                                      startIndex + idx + 1
                                    }`}
                                  />
                                </Grid>
                              ))}
                          </Grid>
                        );
                      })}
                    </Grid>
                  )}
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Border between hats */}
          {index !== styles.length - 1 && (
            <Box
              sx={{ borderBottom: "1px solid #193059", marginTop: "30px" }}
            />
          )}
        </Box>
      ))}
    </Box>
  );
};

export default HatStylesPage;
